export const getRulesFrag = `
    resource
    action
    group
    globalAccess
`;
